import { Container, Icon, Link, Text } from "@chakra-ui/react";
import { Link as GatsbyLink } from "gatsby";
import { ReactComponent as ESCDA2025Logo } from "src/assets/icons/ESCDA2025.svg";
import { useIsESCDA2025Enabled } from "src/hooks/useIsESCDA2025Enabled";

const LINK_URL = "/conseillers";

export const ESCDA2025Banner = () => {
  const { isESCDA2025Enabled } = useIsESCDA2025Enabled();

  if (!isESCDA2025Enabled) {
    return null;
  }

  return (
    <Container
      alignItems="center"
      backgroundColor="blue-2"
      display={{
        base: "none",
        lg: "flex",
      }}
      gap="space-16"
      justifyContent="center"
      paddingY={12.33}
      width="100%"
    >
      <Icon alt="ESCDA2025" as={ESCDA2025Logo} height="auto" width={25} />

      <Text fontWeight="medium" variant="primary">
        Shine, Élu Service Client de l’Année 2025*
      </Text>

      <Link
        as={GatsbyLink}
        to={LINK_URL}
        textDecorationLine="underline"
        style={{
          textDecorationSkipInk: "none",
          textUnderlinePosition: "from-font",
        }}
      >
        En savoir plus
      </Link>
    </Container>
  );
};
